package ru.villawonka.app.presentation.screens.search.compose.view

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.tween
import androidx.compose.animation.expandVertically
import androidx.compose.animation.shrinkVertically
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.material.Icon
import androidx.compose.material.IconButton
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.onSurfacePrimary
import ru.villawonka.app.presentation.design.theme.surfaceMiddle
import ru.villawonka.app.presentation.model.CountryUIModel
import ru.villawonka.app.presentation.screens.search.model.SearchCategoryUIModel
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.header_logo
import villawonka.composeapp.generated.resources.ic_map_pin_16
import villawonka.composeapp.generated.resources.ic_settings_24

@Composable
internal fun SearchTopBar(
    country: CountryUIModel,
    selectedSearchCategory: SearchCategoryUIModel,
    searchCategories: List<SearchCategoryUIModel>,
    listState: LazyListState,
    onTabSelect: (SearchCategoryUIModel) -> Unit,
    onStartButtonClick: () -> Unit,
    onEndButtonClick: () -> Unit,
) {
    val isNeedTabBarShow by derivedStateOf { listState.firstVisibleItemIndex == 0 }

    val enterTransition = expandVertically(animationSpec = tween(300, 0))
    val exitTransition = shrinkVertically(animationSpec = tween(300, 0))

    AnimatedVisibility(
        visible = isNeedTabBarShow,
        enter = enterTransition,
        exit = exitTransition
    ) {
        Column {
            SearchHeaderView(
                country = country,
                onStartButtonClick = onStartButtonClick,
                onEndButtonClick = onEndButtonClick,
            )
            SearchCategoriesView(
                tabItems = searchCategories.map { it.tabItem },
                selectedItem = selectedSearchCategory.tabItem,
                onTabSelect = { tabItem ->
                    onTabSelect(
                        searchCategories.first { it.tabItem == tabItem }
                    )
                }
            )
        }
    }
}

@Composable
private fun SearchHeaderView(
    country: CountryUIModel,
    onStartButtonClick: () -> Unit,
    onEndButtonClick: () -> Unit
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .background(MaterialTheme.colors.surfaceMiddle)
            .padding(
                top = 24.dp,
                bottom = 8.dp,
                start = 8.dp,
                end = 8.dp
            )
    ) {
        Column(
            modifier = Modifier.align(Alignment.Center),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Image(
                painter = painterResource(Res.drawable.header_logo),
                contentDescription = null,
                modifier = Modifier.width(180.dp),
                colorFilter = ColorFilter.tint(MaterialTheme.colors.onSurfacePrimary)
            )
            AppSpacer(8.dp)
            Row(
                verticalAlignment = Alignment.CenterVertically
            ) {
                Image(
                    painter = painterResource(country.icon),
                    contentDescription = null,
                    modifier = Modifier.width(20.dp)
                )
                AppSpacer(6.dp)
                Text(
                    text = country.string,
                    style = AppTextStyles.bodySmallRegular
                )
            }
        }
        IconButton(
            onClick = onStartButtonClick,
            content = {
                Icon(
                    painter = painterResource(Res.drawable.ic_map_pin_16),
                    contentDescription = null,
                    modifier = Modifier.size(24.dp)
                )
            },
            modifier = Modifier.align(Alignment.CenterStart)
        )

        IconButton(
            onClick = onEndButtonClick,
            content = {
                Icon(
                    painter = painterResource(Res.drawable.ic_settings_24),
                    contentDescription = null,
                    modifier = Modifier.size(24.dp)
                )
            },
            modifier = Modifier.align(Alignment.CenterEnd)
        )
    }
}

@Composable
private fun SearchCategoriesView(
    selectedItem: TabItem,
    tabItems: List<TabItem>,
    onTabSelect: (TabItem) -> Unit,
) {
    var selectedIndex by remember { mutableStateOf(tabItems.indexOf(selectedItem)) }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .background(MaterialTheme.colors.surfaceMiddle)
            .padding(
                top = 16.dp,
                bottom = 8.dp
            )
    ) {
        TabBar(
            items = tabItems,
            selectedIndex = selectedIndex,
            onClickListener = {
                selectedIndex = it
                onTabSelect(tabItems[it])
            }
        )
    }
}